"use strict";
window.SHIGETA_PAGE = window.SHIGETA_PAGE || {};

(function($$) {
  /** --------------------------------------------------
   * Global Settings
   */
  $$.var = {
    windowWidth: -1,
    windowHeight: -1,
    windowScrollTop: -1,
    windowScrollBottom: -1,
    tmpScrollTop: null,
    windowLazyResizeTimer: false,
    ua: navigator.userAgent
  }
  $$.event = {
    windowLazyResize: 'SHIGETA_PAGE__windowLazyResize',
    switchBreakpoint: 'SHIGETA_PAGE__switchBreakpoint',
    scrollAnimationReached: 'SHIGETA_PAGE__scrollAnimationReached'
  }
  $$.flag = {
    isLoaded: null,
    isDeviceTablet: (/iphone|ipad|ipod|android/i).test($$.var.ua) || ((/macintosh/i).test($$.var.ua) && typeof document.ontouchstart !== 'undefined'),
    tmpIsSP: null
  }
  $$.fn = {
    /** ----------------------------------------
     * コンソールログの出力
     * @param {mix} args 出力内容
     */
    log: (...args) => {
      if(window.console && console.log) {
        console.log(...args);
      }
    },
    /** ----------------------------------------
     * ブレイクポイントの判定
     */
    isPC: () => {
      return (window.innerWidth >= 769);
    },
    isSP: () => {
      return (window.innerWidth < 769);
    },
    /** ----------------------------------------
     * グローバル変数の設定
     */
    setGlobalVariables: () => {
      $$.var.windowWidth = document.documentElement.clientWidth;
      $$.var.windowHeight = document.documentElement.clientHeight;
      $$.var.windowScrollTop = window.pageYOffset;
      $$.var.windowScrollBottom = $$.var.windowScrollTop + $$.var.windowHeight;
    },
    /** ----------------------------------------
     * 要素の位置の取得
     * @param {element} element 位置を取得する要素
     */
    getOffset: (element) => {
      let result = {};
      if(element && element.getBoundingClientRect) {
        let myRect = element.getBoundingClientRect();
        let myRectObj = {
          top: myRect.top + window.pageYOffset,
          left: myRect.left + window.pageXOffset
        }
        Object.assign(result, myRectObj);
      }
      return result;
    },
    /** ----------------------------------------
     * 要素のスタイルの取得
     * @param {element} element       スタイルを取得する要素
     * @param {string}  property      CSSのプロパティ名
     * @param {string}  pseudoElement スタイルを取得する擬似要素
     */
    getCssValue: (element, property, pseudoElement = null) => {
      let result = null;
      if(element && element.nodeType === 1 && property) {
        result = getComputedStyle(element, pseudoElement).getPropertyValue(property);
      }
      return result;
    },
    /** ----------------------------------------
     * スムーススクロール
     * @param {int|element} target 移動先のスクロール位置 or 要素
     * @param {int}         speed  アニメーション速度
     */
    smoothScroll: (target, speed = 400) => {
      let targetPosition = null;
      if(typeof target === 'number') {
        targetPosition = target;
      } else if(target && target.nodeType === 1) {
        targetPosition = Math.ceil($$.fn.getOffset(target).top);

        if($$.elm.header) {
          let headerPositionStyle = getComputedStyle($$.elm.header).getPropertyValue('position');
          if(headerPositionStyle === 'sticky' || headerPositionStyle === 'fixed') {
            targetPosition = targetPosition - $$.elm.header.offsetHeight - parseFloat($$.fn.getCssValue($$.elm.header, 'top'));
          }
        }
      } else {
        return;
      }

      let startTimestamp = null,
          startPosition = window.pageYOffset,
          distance = targetPosition - startPosition;

      const step = (timestamp) => {
        if(!startTimestamp) startTimestamp = timestamp;

        let elapsedTime = Math.round(timestamp - startTimestamp),
            progress = ((elapsedTime / speed) < 1) ? (elapsedTime / speed) : 1,
            stepPosition = startPosition + (distance * progress);

        window.scrollTo(0, stepPosition);

        if(progress < 1) {
          requestAnimationFrame(step);
        }
      }

      requestAnimationFrame(step);
    },
    /** ----------------------------------------
     * body固定
     */
    fixBody: () => {
      $$.var.tmpScrollTop = window.pageYOffset;
      document.body.style.position = 'fixed';
      document.body.style.top      = ($$.var.tmpScrollTop * -1) + 'px';
      document.body.style.left     = 0;
      document.body.style.right    = 0;
    },
    /** ----------------------------------------
     * body固定解除
     */
    unfixBody: () => {
      document.body.style.position = '';
      document.body.style.top      = '';
      document.body.style.left     = '';
      document.body.style.right    = '';
      window.scrollTo(0, $$.var.tmpScrollTop);
      setTimeout(() => {
        $$.var.tmpScrollTop = null;
      }, 0);
    }
  }
  $$.elm = {}

  document.addEventListener('click', (e) => {
    if(e.target && e.target.closest('.js-pg-anchor')) {
      let element = e.target.closest('.js-pg-anchor'),
          target = element.getAttribute('href') || element.getAttribute('data-anchor');
      if(target.match(/^#[0-9A-Za-z]+/)) {
        e.preventDefault();
        let targetElement = document.querySelector(target);
        if(targetElement) {
          $$.fn.smoothScroll(targetElement);
        }
      }
    }
  });

  /** --------------------------------------------------
   * Event Handler
   */
  document.addEventListener('DOMContentLoaded', (e) => {
    $$.flag.tmpIsSP = $$.fn.isSP();
    $$.fn.setGlobalVariables();

    $$.elm.body = document.body;
    $$.elm.header = document.querySelector('#shopify-section-header');

    $$.elm.wrapper = document.querySelector('.pg-l-wrapper');
  });

  window.addEventListener('load', (e) => {
    $$.fn.setGlobalVariables();
    $$.flag.isLoaded = true;

    let hash = location.hash;
    if(hash) {
      let targetElement = document.querySelector(hash);
      $$.fn.smoothScroll(targetElement, 0);
    }
  });

  window.addEventListener('resize', (e) => {
    $$.fn.setGlobalVariables();

    if($$.var.windowLazyResizeTimer !== false) {
      clearTimeout($$.var.windowLazyResizeTimer);
    }
    $$.var.windowLazyResizeTimer = setTimeout(() => {
      window.dispatchEvent(new Event($$.event.windowLazyResize));
    }, 100);

    let isSP = $$.fn.isSP();
    if($$.flag.tmpIsSP !== isSP) {
      window.dispatchEvent(new Event($$.event.switchBreakpoint));
      $$.flag.tmpIsSP = isSP;
    }
  });

  window.addEventListener('scroll', (e) => {
    $$.fn.setGlobalVariables();
  });
})(window.SHIGETA_PAGE);